import { BrowserRouter, Route, Routes } from "react-router-dom";

import SessionModal from "./components/SessionModal";
import { WebAppParams } from "./components/WebAppParams";
import "./index.css";
import LabPage from "./pages/LabPage";
import MainPage from "./pages/MainPage";
// import QRPage from "./pages/QRPage";
import Settings from "./pages/Settings";
import { TutorialProvider } from "./providers/TutorialProvider";

// const isMobile = () => {
//   return /Mobi|Android/i.test(navigator.userAgent);
// };

// CORRECTED

// const isTelegramMobile = () => {
//   const userAgent = navigator.userAgent;
//   const isMobile = /Mobi|Android/i.test(userAgent);
//   const isTelegram = /Telegram/i.test(userAgent);
//   return isMobile && isTelegram;
// };

export const Router = () => {
  return (
    <BrowserRouter>
      <WebAppParams />
      <Routes>
        <Route path="/lab" element={<LabPage />} />
        <Route path="/settings" element={<Settings />} />
        <Route
          path="/"
          element={
            // isMobile() ? (
            <TutorialProvider>
              <MainPage />
            </TutorialProvider>
            // ) : (
            //   <QRPage />
            // )
          }
        />
      </Routes>
      <SessionModal />
    </BrowserRouter>
  );
};
